import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyEpocusUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyEpocusUserQuery = { readonly __typename?: 'Query', readonly myEpocusUser: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly telephone?: string | null, readonly npi?: string | null, readonly reminderEmailEnabled: boolean, readonly reminderEmailTime?: string | null, readonly memberships: ReadonlyArray<{ readonly __typename?: 'EpocusUserMembership', readonly programId: string, readonly programName: string, readonly role: Types.EpocusRole }> } };

export type UpdateMyEpocusUserMutationVariables = Types.Exact<{
  input: Types.UpdateMyEpocusUserInput;
}>;


export type UpdateMyEpocusUserMutation = { readonly __typename?: 'Mutation', readonly updateMyEpocusUser: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly telephone?: string | null, readonly npi?: string | null, readonly reminderEmailEnabled: boolean, readonly reminderEmailTime?: string | null } };

export type EpocusProgramIngressQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramIngressQuery = { readonly __typename?: 'Query', readonly epocusProgramIngress: { readonly __typename?: 'EpocusProgramIngress', readonly programId: string, readonly aeTitle?: string | null, readonly endpoints: ReadonlyArray<{ readonly __typename?: 'EpocusProgramIngressEndpoint', readonly channel: Types.EpocusProgramIngressChannel, readonly enabled: boolean, readonly disabledReason?: string | null, readonly exportUrl?: string | null, readonly username?: string | null, readonly host?: string | null, readonly port?: number | null, readonly calledAeTitle?: string | null, readonly callingAeTitle?: string | null, readonly examples: ReadonlyArray<string>, readonly callingAeTitleRules: ReadonlyArray<{ readonly __typename?: 'EpocusCallingAeTitleRule', readonly vendor: string, readonly callingAeTitle: string }> }> } };

export type EpocusSeedableStudiesQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusSeedableStudiesQuery = { readonly __typename?: 'Query', readonly epocusSeedableStudies: ReadonlyArray<{ readonly __typename?: 'EpocusSeedableStudy', readonly dicomStudyId: string, readonly imageCount: number, readonly cineCount: number }> };

export type EpocusSeedLibraryQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusSeedLibraryQuery = { readonly __typename?: 'Query', readonly epocusSeedLibrary: { readonly __typename?: 'EpocusSeedLibrarySummary', readonly available: boolean, readonly version?: string | null, readonly byExamType: ReadonlyArray<{ readonly __typename?: 'EpocusSeedLibraryExamTypeCount', readonly examType: Types.EpocusExamType, readonly stills: number, readonly cines: number }>, readonly attribution: ReadonlyArray<{ readonly __typename?: 'EpocusSeedLibraryAttribution', readonly dataset: string, readonly title: string, readonly licence: string, readonly url?: string | null }> } };

export type SeedEpocusDemoStudiesMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  count: Types.Scalars['Int'];
  kind: Types.EpocusSeedKind;
  deviceSerialNumber?: Types.InputMaybe<Types.Scalars['String']>;
  source?: Types.InputMaybe<Types.EpocusSeedSource>;
  examTypes?: Types.InputMaybe<ReadonlyArray<Types.EpocusExamType> | Types.EpocusExamType>;
}>;


export type SeedEpocusDemoStudiesMutation = { readonly __typename?: 'Mutation', readonly seedEpocusDemoStudies: ReadonlyArray<{ readonly __typename?: 'EpocusSeededDemoStudy', readonly encounterId: string, readonly dicomStudyId: string, readonly imageCount: number, readonly cineCount: number, readonly examType?: Types.EpocusExamType | null }> };

export type ClearEpocusSeededDemoStudiesMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type ClearEpocusSeededDemoStudiesMutation = { readonly __typename?: 'Mutation', readonly clearEpocusSeededDemoStudies: { readonly __typename?: 'EpocusClearedSeededDemoStudies', readonly programId: string, readonly clearedCount: number } };


export const MyEpocusUserDocument = gql`
    query MyEpocusUser {
  myEpocusUser {
    id
    firstName
    lastName
    email
    telephone
    npi
    reminderEmailEnabled
    reminderEmailTime
    memberships {
      programId
      programName
      role
    }
  }
}
    `;

/**
 * __useMyEpocusUserQuery__
 *
 * To run a query within a React component, call `useMyEpocusUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEpocusUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEpocusUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEpocusUserQuery(baseOptions?: Apollo.QueryHookOptions<MyEpocusUserQuery, MyEpocusUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEpocusUserQuery, MyEpocusUserQueryVariables>(MyEpocusUserDocument, options);
      }
export function useMyEpocusUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEpocusUserQuery, MyEpocusUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEpocusUserQuery, MyEpocusUserQueryVariables>(MyEpocusUserDocument, options);
        }
export type MyEpocusUserQueryHookResult = ReturnType<typeof useMyEpocusUserQuery>;
export type MyEpocusUserLazyQueryHookResult = ReturnType<typeof useMyEpocusUserLazyQuery>;
export type MyEpocusUserQueryResult = Apollo.QueryResult<MyEpocusUserQuery, MyEpocusUserQueryVariables>;
export const UpdateMyEpocusUserDocument = gql`
    mutation UpdateMyEpocusUser($input: UpdateMyEpocusUserInput!) {
  updateMyEpocusUser(input: $input) {
    id
    firstName
    lastName
    email
    telephone
    npi
    reminderEmailEnabled
    reminderEmailTime
  }
}
    `;
export type UpdateMyEpocusUserMutationFn = Apollo.MutationFunction<UpdateMyEpocusUserMutation, UpdateMyEpocusUserMutationVariables>;

/**
 * __useUpdateMyEpocusUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyEpocusUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyEpocusUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyEpocusUserMutation, { data, loading, error }] = useUpdateMyEpocusUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyEpocusUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyEpocusUserMutation, UpdateMyEpocusUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyEpocusUserMutation, UpdateMyEpocusUserMutationVariables>(UpdateMyEpocusUserDocument, options);
      }
export type UpdateMyEpocusUserMutationHookResult = ReturnType<typeof useUpdateMyEpocusUserMutation>;
export type UpdateMyEpocusUserMutationResult = Apollo.MutationResult<UpdateMyEpocusUserMutation>;
export type UpdateMyEpocusUserMutationOptions = Apollo.BaseMutationOptions<UpdateMyEpocusUserMutation, UpdateMyEpocusUserMutationVariables>;
export const EpocusProgramIngressDocument = gql`
    query EpocusProgramIngress($programId: ID!) {
  epocusProgramIngress(programId: $programId) {
    programId
    aeTitle
    endpoints {
      channel
      enabled
      disabledReason
      exportUrl
      username
      host
      port
      calledAeTitle
      callingAeTitle
      callingAeTitleRules {
        vendor
        callingAeTitle
      }
      examples
    }
  }
}
    `;

/**
 * __useEpocusProgramIngressQuery__
 *
 * To run a query within a React component, call `useEpocusProgramIngressQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramIngressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramIngressQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramIngressQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramIngressQuery, EpocusProgramIngressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramIngressQuery, EpocusProgramIngressQueryVariables>(EpocusProgramIngressDocument, options);
      }
export function useEpocusProgramIngressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramIngressQuery, EpocusProgramIngressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramIngressQuery, EpocusProgramIngressQueryVariables>(EpocusProgramIngressDocument, options);
        }
export type EpocusProgramIngressQueryHookResult = ReturnType<typeof useEpocusProgramIngressQuery>;
export type EpocusProgramIngressLazyQueryHookResult = ReturnType<typeof useEpocusProgramIngressLazyQuery>;
export type EpocusProgramIngressQueryResult = Apollo.QueryResult<EpocusProgramIngressQuery, EpocusProgramIngressQueryVariables>;
export const EpocusSeedableStudiesDocument = gql`
    query EpocusSeedableStudies($programId: ID!) {
  epocusSeedableStudies(programId: $programId) {
    dicomStudyId
    imageCount
    cineCount
  }
}
    `;

/**
 * __useEpocusSeedableStudiesQuery__
 *
 * To run a query within a React component, call `useEpocusSeedableStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusSeedableStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusSeedableStudiesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusSeedableStudiesQuery(baseOptions: Apollo.QueryHookOptions<EpocusSeedableStudiesQuery, EpocusSeedableStudiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusSeedableStudiesQuery, EpocusSeedableStudiesQueryVariables>(EpocusSeedableStudiesDocument, options);
      }
export function useEpocusSeedableStudiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusSeedableStudiesQuery, EpocusSeedableStudiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusSeedableStudiesQuery, EpocusSeedableStudiesQueryVariables>(EpocusSeedableStudiesDocument, options);
        }
export type EpocusSeedableStudiesQueryHookResult = ReturnType<typeof useEpocusSeedableStudiesQuery>;
export type EpocusSeedableStudiesLazyQueryHookResult = ReturnType<typeof useEpocusSeedableStudiesLazyQuery>;
export type EpocusSeedableStudiesQueryResult = Apollo.QueryResult<EpocusSeedableStudiesQuery, EpocusSeedableStudiesQueryVariables>;
export const EpocusSeedLibraryDocument = gql`
    query EpocusSeedLibrary($programId: ID!) {
  epocusSeedLibrary(programId: $programId) {
    available
    version
    byExamType {
      examType
      stills
      cines
    }
    attribution {
      dataset
      title
      licence
      url
    }
  }
}
    `;

/**
 * __useEpocusSeedLibraryQuery__
 *
 * To run a query within a React component, call `useEpocusSeedLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusSeedLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusSeedLibraryQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusSeedLibraryQuery(baseOptions: Apollo.QueryHookOptions<EpocusSeedLibraryQuery, EpocusSeedLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusSeedLibraryQuery, EpocusSeedLibraryQueryVariables>(EpocusSeedLibraryDocument, options);
      }
export function useEpocusSeedLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusSeedLibraryQuery, EpocusSeedLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusSeedLibraryQuery, EpocusSeedLibraryQueryVariables>(EpocusSeedLibraryDocument, options);
        }
export type EpocusSeedLibraryQueryHookResult = ReturnType<typeof useEpocusSeedLibraryQuery>;
export type EpocusSeedLibraryLazyQueryHookResult = ReturnType<typeof useEpocusSeedLibraryLazyQuery>;
export type EpocusSeedLibraryQueryResult = Apollo.QueryResult<EpocusSeedLibraryQuery, EpocusSeedLibraryQueryVariables>;
export const SeedEpocusDemoStudiesDocument = gql`
    mutation SeedEpocusDemoStudies($programId: ID!, $count: Int!, $kind: EpocusSeedKind!, $deviceSerialNumber: String, $source: EpocusSeedSource, $examTypes: [EpocusExamType!]) {
  seedEpocusDemoStudies(
    programId: $programId
    count: $count
    kind: $kind
    deviceSerialNumber: $deviceSerialNumber
    source: $source
    examTypes: $examTypes
  ) {
    encounterId
    dicomStudyId
    imageCount
    cineCount
    examType
  }
}
    `;
export type SeedEpocusDemoStudiesMutationFn = Apollo.MutationFunction<SeedEpocusDemoStudiesMutation, SeedEpocusDemoStudiesMutationVariables>;

/**
 * __useSeedEpocusDemoStudiesMutation__
 *
 * To run a mutation, you first call `useSeedEpocusDemoStudiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedEpocusDemoStudiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedEpocusDemoStudiesMutation, { data, loading, error }] = useSeedEpocusDemoStudiesMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      count: // value for 'count'
 *      kind: // value for 'kind'
 *      deviceSerialNumber: // value for 'deviceSerialNumber'
 *      source: // value for 'source'
 *      examTypes: // value for 'examTypes'
 *   },
 * });
 */
export function useSeedEpocusDemoStudiesMutation(baseOptions?: Apollo.MutationHookOptions<SeedEpocusDemoStudiesMutation, SeedEpocusDemoStudiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedEpocusDemoStudiesMutation, SeedEpocusDemoStudiesMutationVariables>(SeedEpocusDemoStudiesDocument, options);
      }
export type SeedEpocusDemoStudiesMutationHookResult = ReturnType<typeof useSeedEpocusDemoStudiesMutation>;
export type SeedEpocusDemoStudiesMutationResult = Apollo.MutationResult<SeedEpocusDemoStudiesMutation>;
export type SeedEpocusDemoStudiesMutationOptions = Apollo.BaseMutationOptions<SeedEpocusDemoStudiesMutation, SeedEpocusDemoStudiesMutationVariables>;
export const ClearEpocusSeededDemoStudiesDocument = gql`
    mutation ClearEpocusSeededDemoStudies($programId: ID!) {
  clearEpocusSeededDemoStudies(programId: $programId) {
    programId
    clearedCount
  }
}
    `;
export type ClearEpocusSeededDemoStudiesMutationFn = Apollo.MutationFunction<ClearEpocusSeededDemoStudiesMutation, ClearEpocusSeededDemoStudiesMutationVariables>;

/**
 * __useClearEpocusSeededDemoStudiesMutation__
 *
 * To run a mutation, you first call `useClearEpocusSeededDemoStudiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearEpocusSeededDemoStudiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearEpocusSeededDemoStudiesMutation, { data, loading, error }] = useClearEpocusSeededDemoStudiesMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useClearEpocusSeededDemoStudiesMutation(baseOptions?: Apollo.MutationHookOptions<ClearEpocusSeededDemoStudiesMutation, ClearEpocusSeededDemoStudiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearEpocusSeededDemoStudiesMutation, ClearEpocusSeededDemoStudiesMutationVariables>(ClearEpocusSeededDemoStudiesDocument, options);
      }
export type ClearEpocusSeededDemoStudiesMutationHookResult = ReturnType<typeof useClearEpocusSeededDemoStudiesMutation>;
export type ClearEpocusSeededDemoStudiesMutationResult = Apollo.MutationResult<ClearEpocusSeededDemoStudiesMutation>;
export type ClearEpocusSeededDemoStudiesMutationOptions = Apollo.BaseMutationOptions<ClearEpocusSeededDemoStudiesMutation, ClearEpocusSeededDemoStudiesMutationVariables>;